import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FeaturesComponent } from '../../userEntityModals/features/features.component';
import { ValidationService } from '../../validation.service';
import { SnackbarService } from '../../snackbar.service';
import { HttpService } from '../../http.service';
// import { _ } from 'underscore';
import * as _ from 'underscore';
import { Subscription } from 'rxjs';
import { EventService } from '../../event.service';
import { StorageService } from '../../storage.service';
import { Router } from '@angular/router';
import {Messages} from '../../constants/messages';
import { environment } from 'src/environments/environment';

declare var google: any;

export interface NewEntity {
  name: string;
  location: any;
  features: string[];
  sub_features: string[];
}

@Component({
  selector: 'app-add-unit',
  templateUrl: './add-unit.component.html',
  styleUrls: ['./add-unit.component.scss']
})
export class AddUnitComponent implements OnInit {
  entityColumns: string[] = ['name', 'address', 'city', 'features', 'subFeatures', 'actions'];
  entityArray: any = [
    // { name: 'unit 1', address: 'indiranagar', city: 'bangalore', features: '', subFeatures: 'create order', actions: '' }
  ];
  features: any;
  selectedFeatures: any = [];
  newEntityData: NewEntity = {
    name: '',
    location: {
      city: '',
      area: '',
      latitude:0,
      longitude:0
    },
    features: [],
    sub_features: []
  };
  countries = []
  selectedCountry = []
  updateEntityData: any = {
    unit_name: '',
    location: {
      city: '',
      area: '',
      mobile:'',
      contact_name:'',
      pincode:''
    },
    features: [],
    sub_features: []
  };
  editUnit = false;
  preSelectedFeatures = [];
  preSelectedSubFeatures = [];
  showLoader = false;
  messages = new Messages();
  dataToSend : any = {}
  carrierUpdates: Subscription;
  country;
  showFeatures =false;
  helpData = [
    { head: 'Head', data: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry' },
    { head: 'Head', data: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry' },
  ];

  constructor(private dialog: MatDialog, private dialog_r: MatDialogRef<AddUnitComponent>, private valid: ValidationService, private snackbar: SnackbarService, private http: HttpService,
              private events: EventService, private storage: StorageService, private route: Router, @Inject (MAT_DIALOG_DATA) private parentData: any) {
  const access_token = this.storage.getFromCookie('access_token');
  this.country = environment.country;
  if (!access_token) {
    this.route.navigateByUrl('login');
  }
              }

  ngOnInit() {
    this.getCountryCodes();
    if (this.parentData && this.parentData.edit) {
      this.preFill();
    }
    this.getfeatures();
    // this.initAutoSuggestions();
  }

  preFill() {
    this.editUnit = this.parentData.edit;
    this.showLoader = true;
    this.http.get('carrier/entity?carrier=' + this.parentData.data).subscribe(
        (data: any) => {
         if (data.statusCode === 200) {
           this.showLoader = false;
           this.newEntityData.name = data.data.entity[0].name;
           this.newEntityData.location.area = data.data.entity[0].location.area;
           this.newEntityData.location.city = data.data.entity[0].location.city;
           this.newEntityData.location.country_code = data.data.entity[0].location.country_code;
           this.newEntityData.location.mobile = data.data.entity[0].location.mobile;
           this.newEntityData.location.contact_name = data.data.entity[0].location.contact_name;
           this.newEntityData.location.pincode = data.data.entity[0].location.pincode;
           this.newEntityData.location.locality = data.data.entity[0].location.locality;
           this.preSelectedFeatures = data.data.entity[0].features;
           this.preSelectedSubFeatures = data.data.entity[0].sub_features;
           this.newEntityData.features = data.data.entity[0].features.map(item => item._id);
           this.newEntityData.sub_features = data.data.entity[0].sub_features.map(item => item._id);
          // this.selectedVehicles = data.data.vehicle_types.map(item => item._id);
          // this.newEntityData.vehicle_types = data.data.vehicle_types.map(item => item._id);
         }
        },
        (err: any) => {
          this.showLoader = false;
          this.snackbar.openSnackBar(err.error.message, '', 'err');
        }
      );
  }

  getfeatures() {
    this.http.get('constants/auth?type=FEATURE').subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          this.features = data.data;
          this.features.forEach(ele => {
            ele.auth_children.sort((a, b) => (a.name > b.name) ? 1 : -1);
          });
        } else {
          this.snackbar.openSnackBar(this.messages.ENTITY_DETAILS.ERROR.FEATURES_NOT_FOUND, '', 'err');
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
        if (err.error.statusCode == 401) {
          this.valid.logout();
        }
      }
    );
  }

  validate() {
    if (!this.valid.isEmpty(this.newEntityData.name) && !this.valid.isEmpty(this.newEntityData.location.area) && !this.valid.isEmpty(this.newEntityData.location.city) && !this.valid.isEmpty(this.newEntityData.location.pincode)) {
      if (!this.newEntityData.features.length && !this.newEntityData.sub_features.length) {
        this.snackbar.openSnackBar(this.messages.ENTITY_DETAILS.VALIDATION.SELECT_FEATURE, '', 'err');
        return false;
      } else if (this.newEntityData.location.mobile && !this.valid.isMobile(this.newEntityData.location.mobile)) {
        this.snackbar.openSnackBar('Invalid Mobile number', '', 'err');
        return false;
      }else if((this.parentData.edit == false && !this.valid.isEmpty(this.newEntityData.location.country_code))) {
        this.snackbar.openSnackBar('Country is required', '', 'err');
        return false;
      }else{
        return true;
      }
    } else {
      this.snackbar.openSnackBar(this.messages.ENTITY_DETAILS.VALIDATION.FILL_ALL, '', 'err');
      return false;
    }
  }

  getCountryCodes(){
    this.http.get('country/all').subscribe((response:any)=>{
      if(response.statusCode == 200){
        this.countries = response.data;
      }
    },
    (err)=>{
      this.snackbar.openSnackBar(err.error.message,'','err');
    })
  }

  selectCountry(country){
    this.selectedCountry = country;
    this.newEntityData.location.country_code = country.iso_alpha_code;
  }

  initAutoSuggestions() {
    const input = document.getElementById('addressSearch');
    const options = {};
    const autoComplete = new google.maps.places.Autocomplete(input, options);
    const context = this.newEntityData;
    autoComplete.addListener('place_changed', () => {

      const place = autoComplete.getPlace();
      context.location.latitude = place.geometry.location.lat();
      context.location.longitude = place.geometry.location.lng();
      context.location.area = place.formatted_address;
      context.location.country_code = (place.address_components[place.address_components.length - 2 ].types.includes('country')) ? place.address_components[place.address_components.length - 2 ].short_name : ''; // "country_code"
      context.location.pincode = (place.address_components[place.address_components.length - 1 ].types.includes('postal_code')) ? place.address_components[place.address_components.length - 1 ].long_name : ''; // "postal_code"

      const city = _.filter(place.address_components, (city) => {
        if (_.contains(city.types, 'locality')) {
          return city.long_name;
        } else if (_.contains(city.types, 'administrative_area_level_1')) {
          return city.long_name;
        }
      });
      context.location.city = city[0].long_name;

      if (!place.geometry) {
        return;
      }
    });
  }

  getFeaturesFromChild(features: any = {}) {
    this.showFeatures = false;
    this.selectedFeatures = features;
    this.newEntityData.features = [];
    this.newEntityData.sub_features = [];
    this.selectedFeatures.forEach(element => {
      if (element.checked == true) {
        this.newEntityData.features.push(element._id);
      } else {
        if (element.subFeatures && element.subFeatures.length) {
          element.subFeatures.forEach(item => {
            if (item.checked == true) {
              this.newEntityData.sub_features.push(item._id);
            }
          });
        }
      }
    });
  }

  openFeaturesModal() {
    console.log(this.features);
    this.dataToSend = {
      selectedFeatures: this.selectedFeatures.length ? this.selectedFeatures : this.features,
      preSelectedFeatures: this.preSelectedFeatures,
      preSelectedSubFeatures: this.preSelectedSubFeatures,
      edit: this.parentData.edit ? this.parentData.edit : false
    };
    this.showFeatures = !this.showFeatures;
  }

  submit() {
    const valid = this.validate();
    if (valid) {
      if (!this.parentData.edit) {
      this.showLoader = true;
      this.http.post('carrier/entity/add', this.newEntityData).subscribe(
        (data: any) => {
          if (data.statusCode == 200) {
            this.showLoader = false;
            this.snackbar.openSnackBar(this.messages.ENTITY_DETAILS.SUCCESS.ENTITY_ADD, '');
            this.newEntityData = {
              name: '',
              location: {
                city: '',
                area: ''
              },
              features: [],
              sub_features: []
            };
            this.features = [];
            this.selectedFeatures = [];
            const existing = JSON.parse(localStorage.getItem('carriers'));
            existing.push(data.data);
            localStorage.removeItem('carriers');
            localStorage.setItem('carriers', JSON.stringify(existing));
            this.closeDialog(data);
          }
        },
        (err: any) => {
          this.showLoader = false;
          this.snackbar.openSnackBar(err.error.message, '', 'err');
          if (err.error.statusCode == 401) {
            this.valid.logout();
          }
        }
      );
      }
      if (this.parentData && this.parentData.edit) {
        this.updateEntityData.unit_name = this.newEntityData.name;
        this.updateEntityData.location.area = this.newEntityData.location.area;
        this.updateEntityData.location.city = this.newEntityData.location.city;
        this.updateEntityData.location.mobile = this.newEntityData.location.mobile;
        this.updateEntityData.location.pincode = this.newEntityData.location.pincode;
        this.updateEntityData.location.locality = this.newEntityData.location.locality;
        // this.updateEntityData.location.country_code = this.newEntityData.location.country_code;
        this.updateEntityData.location.contact_name = this.newEntityData.location.contact_name;
        this.updateEntityData.features = this.newEntityData.features;
        this.updateEntityData.sub_features = this.newEntityData.sub_features;
        this.showLoader = true;
        this.http.post('carrier/entity/' + this.parentData.data, this.updateEntityData).subscribe(
          (data: any) => {
            if (data.statusCode === 200) {
              this.showLoader = false;
              this.newEntityData = {
                name: '',
                location: {
                  city: '',
                  area: ''
                },
                features: [],
                sub_features: []
              };
              // this.features = [];
              // this.selectedFeatures = [];
              this.snackbar.openSnackBar(this.messages.ENTITY_DETAILS.SUCCESS.ENTITY_UPDATE, '');
              const existing = JSON.parse(localStorage.getItem('carriers'));
              existing.push(data.data);
              localStorage.removeItem('carriers');
              localStorage.setItem('carriers', JSON.stringify(existing));
              this.closeDialog(data);
            }
          },
          (err: any) => {
            this.showLoader = false;
            this.snackbar.openSnackBar(err.error.message, '', 'err');
            if (err.error.statusCode === 401) {
              this.valid.logout();
            }
          }
        );
      }
    }
  }

  closeDialog(data) {
    this.dialog_r.close(data);
  }

}
